var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-card"},[_c('p',{staticClass:"header"},[_vm._v(_vm._s(_vm.name))]),_c('v-btn',{attrs:{"depressed":"","data-cursor-hover":""},on:{"click":_vm.redirect}},[_vm._v(" Visit Profile ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }